
import marked from '@/mixins/marked'
export default {
  props: {
    index: Number,
    item: Object,
    step: Object,
  },

  mixins: [marked],

  data() {
    return {
      isReady: false,
      videoAction: '',
      currentVideo: '',
    }
  },

  computed: {
    _step: {
      set(value) {
        this.$emit('update:step', value)
      },

      get() {
        return this.step
      },
    },
    conditionCenter() {
      return (
        !this.item.content.inputs ||
        this.item.content.inputs.length === 0 ||
        (this.item.content.inputs.length > 0 &&
          this.item.content.inputs[0].modules === null)
      )
    },
    hasModules() {
      return (
        this.item.content.inputs
          .map((i) => i.modules)
          .map((m) => (!m ? false : true))
          .includes(true) &&
        this.item.content.inputs?.[0]?.modules?.[0].isVisible !== false
      )
    },
  },

  watch: {
    step: {
      handler(val) {
        // console.log('STEP', val)
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    getCurrentVideo() {
      if (window.innerHeight > window.innerWidth) {
        this.currentVideo = 'portrait'
        this.videoAction = ''
      } else {
        this.currentVideo = 'landscape'
        this.videoAction = ''
      }
    },
  },

  mounted() {
    if (!this.step) this._step = {}
    if (!this.hasModules) this.$emit('valid', true)
    this.isReady = true

    this.getCurrentVideo()
    window.addEventListener('resize', this.getCurrentVideo)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getCurrentVideo)
  },
}
